import type { DeviationFE, DeviationSeverityFE } from 'domain/vehicle';
import { getTopCriticalSeverity } from 'helper/severityRank';

export const setSeverity = (deviations: DeviationFE[] | undefined): DeviationSeverityFE =>
    getTopCriticalSeverity(deviations) ?? 'UNKNOWN';
